"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCTS = void 0;
var PRODUCTS = {
  INPUT__SEARCH: 'inventoryRemovalProducts-input-search',
  INPUT__QUANTITY: 'inventoryRemovalProducts-input-quantity',
  BUTTON__SELECTED: 'inventoryRemovalProducts-button-selected',
  BUTTON__SELECT: 'inventoryRemovalProducts-button-select'
};
exports.PRODUCTS = PRODUCTS;